import Navbar from './component/Navbar'
import Home from './component/Home';
import React, { useState } from "react";
import './App.css';
import Footer from './component/Footer';
import Copyright from './component/Copyright';
import Subject from './component/Subject';
import Preparation1 from './component/Preparation1';
import Preparation2 from './component/Preparation2';
import Councelling1 from './component/Councelling1';
import Councelling2 from './component/Councelling2';
import About from './component/About';
import Services from './component/Services';
import Contact from './component/Contact';
import Blog from './component/Blog';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './component/Login';
import Reagister from './component/Reagister';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoadingBar from 'react-top-loading-bar'
import Spoken from './component/spoken';



function App() {
  const [progress, setProgress] = useState(0)
  return (
    <div>
      <BrowserRouter>
      <LoadingBar
        color='#f11946'
        height={3}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Navbar setProgress={setProgress}/>
       <Routes>
         <Route exact path="/" element={<Home />}/>
         <Route exact path="/about" element={<About/>}/>
         <Route exact path="/services" element={<Services/>}/>
         <Route exact path="/subject" element={<Subject/>}/>
         <Route exact path="/contact" element={<Contact setProgress={setProgress}/>}/>
         <Route exact path="/preparation1" element={<Preparation1/>}/>
         <Route exact path="/preparation2" element={<Preparation2/>}/>
         <Route exact path="/councelling1" element={<Councelling1/>}/>
         <Route exact path="/councelling2" element={<Councelling2/>}/>
         <Route exact path="/blog" element={<Blog/>}/>
         <Route exact path="/login" element={<Login  setProgress={setProgress}/>}/>
         <Route exact path="/spoken" element={<Spoken/>}/>
         <Route exact path="/register" element={<Reagister  setProgress={setProgress}/>}/>
       </Routes>
       <Footer/>
       <Copyright/>
      </BrowserRouter>
    </div>
  );
}

export default App;
